import React from 'react';

interface SecureSignInLoaderProps {
  message?: string;
}

const SecureSignInLoader: React.FC<SecureSignInLoaderProps> = ({
  message = 'Securing your sign-in...',
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#1a1a1a',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <img
        src="/assets/logoWithText.svg"
        alt="Txt2Creative Logo"
        style={{
          width: '150px',
          height: 'auto',
          marginBottom: '20px',
        }}
      />
      <div
        style={{
          width: '40px',
          height: '40px',
          border: '4px solid #555',
          borderTop: '4px solid #007bff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '20px',
        }}
      />
      <p style={{ fontSize: '18px', color: '#fff' }}>{message}</p>
      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default SecureSignInLoader;
